import type { FC, SVGAttributes } from 'react';
import React from 'react';

export const Icon: FC<SVGAttributes<SVGSVGElement>> = ({ className, ...rest }) => (
    <svg className={className} viewBox="1.6 0 3.4 8.3" xmlns="http://www.w3.org/2000/svg" {...rest}>
        <path d="M1.048 1.399v8.299l3.402-4.15-3.402-4.15z" fill="none" />
    </svg>
);
